/**
 * @file menu-slice.ts
 * @description Redux slice для управления состоянием навигационного меню в Task Manager приложении. Обеспечивает загрузку структуры меню с сервера, управление активными элементами главного меню и подменю, а также состояниями загрузки для динамической навигации по разделам системы.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@reduxjs/toolkit', '@api/config', '@src/types', '@store/index']
 * @related-files ['src/components/layouts/sidebar', 'src/routes/generate-routes.tsx', 'src/api/config.ts', 'src/types/menu.types.ts']
 */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import instance from '@api/config';
import { TMenuItem } from '@src/types';
import { RootState } from '@store/index';

export interface MenuState {
    activeMainMenuGroup: TMenuItem | null;
    activeMainMenuItem: TMenuItem | null;
    mainMenuItems: TMenuItem[];
    submenuItems: TMenuItem[];
    loading: boolean;
    error: any;
}

const initialState: MenuState = {
    activeMainMenuGroup: null,
    activeMainMenuItem: null,
    mainMenuItems: [],
    submenuItems: [],
    loading: true,
    error: null
};

export const fetchMenuItems = createAsyncThunk('menu/fetchItems', async () => {
    const response = await instance().get('menu');

    return response.data;
});

export const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setActiveGroup(state, { payload }): any {
            state.activeMainMenuGroup = payload;
        },
        setActiveItem(state, { payload }): any {
            state.activeMainMenuItem = payload;
        },
        setSubmenuItems(state, { payload }): any {
            state.submenuItems = payload;
        },
        setMenuItems(state, action): any {
            state.mainMenuItems = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMenuItems.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchMenuItems.fulfilled, (state, { payload }: any) => {
            state.loading = false;
            state.mainMenuItems = payload;
        });
        builder.addCase(fetchMenuItems.rejected, (state, { payload }: any) => {
            state.loading = false;
            state.error = payload;
        });
    }
});
export const { setActiveGroup, setActiveItem, setSubmenuItems, setMenuItems } = menuSlice.actions;
export const getActiveMainMenuGroup = (state: RootState): TMenuItem | null => state.menuStore.activeMainMenuGroup;
export const getActiveMainMenuItem = (state: RootState): TMenuItem | null => state.menuStore.activeMainMenuItem;
export const getMainMenuItems = (state: RootState): TMenuItem[] => state.menuStore.mainMenuItems;
export const getSubmenuItems = (state: RootState): TMenuItem[] => state.menuStore.submenuItems;

export default menuSlice.reducer;
